import { call, put, fork, takeLatest } from 'redux-saga/effects';

import { restClient } from 'config/store/configureStore';

import * as types from 'constants/ActionTypes';

import * as derivativeActions from '../actions/derivativeActions';

// GET SPECIFIC DERIVATIVE

function* fetchDerivative({ payload, meta }) {
  const { request } = payload;
  const { code, modelId } = meta;
  try {
    const response = yield call(restClient.request, request);
    yield put(derivativeActions.fetchDerivativeSuccess(response.data, modelId, code));
  } catch (e) {
    yield put(derivativeActions.fetchDerivativeFailure(e));
  }
}

function* fetchDerivativeWatcher() {
  yield takeLatest(types.FETCH_DERIVATIVE_REQUEST, fetchDerivative);
}

const DerivativeSagas = [fork(fetchDerivativeWatcher)];

export default DerivativeSagas;
